import React, { useState } from 'react';
import { Radio, Space, Input, Checkbox } from 'antd';
import { QuestionWrapper, 
  QuestionText,
  RadioField,
  CheckboxField,
  ButtonContainer,
  PrevButton,
  NextButton,
  SubQuestionWrapper,
  SubQuestionText
} from "./styled";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";

const { TextArea } = Input;

type Props = {
  data: any;
  updateHours: any;
  isLast: boolean;
  isFirst: boolean;
  calculateHours: any;
  appType: number;
  handlePrev: any;
  formData: any;
  setFormData: any;
};

const Question: React.FC<Props> = ({data, updateHours, isLast, isFirst, calculateHours, appType, handlePrev, formData, setFormData}) => {
  const [showTextarea, setShowTextarea] = useState(false);
  const [showSubQues, setShowSubQues] = useState(false);
  const [hours, setHours] = useState(0);
  const [optionId, setOptionId] = useState();
  const [subQuesHours, setSubQuesHours]: any = useState({});
  const btnText = isLast ? "Finish" : "Next";

  const handleNext = () => {
    //Close the textarea if opened
    setShowTextarea(false);

    // Calculate total hours including sub features
    let totalHours = 0;
    Object.values(subQuesHours).forEach((value:any) => {
      totalHours = totalHours + value;
    });

    totalHours = totalHours + hours;

    if (isLast) {
      calculateHours(totalHours);
    }else {
      updateHours(totalHours, optionId);
    }
  }

  const handleRadioClick = (option: any, quesId: number) => {
    setOptionId(option.id);
    if (option?.extra?.type === "Textarea") {
      setShowTextarea(true);
    }else {
      setShowTextarea(false);
    }

    if (typeof option.hours === "object") {
      setHours(option.hours[appType])
    }else {
      setHours(option.hours);
    }

    // Set data for form
    if (quesId === 1) {
      let websiteFor = option.id === 3 ? "Other" : option.value;
      setFormData({...formData, what_is_this_website_for:websiteFor});
    }
  }

  const handleCheckboxClick = (e: any, option: any) => {
    if (option?.extra?.type === "Textarea") {
      setShowTextarea(true);
    }else {
      setShowTextarea(false);
    }
    let isChecked = e.target.checked;
    let newHours;
    if (isChecked) {
      newHours = hours + option.hours;
    }else {
      newHours = hours - option.hours;
    }
    setHours(newHours);
  }

  const handleConditionalClick = (option: any) => {
    if (option.value === 'Yes') {
      setShowSubQues(true);
    }else {
      setShowSubQues(false);
    }
  }

  const handleSubQuesClick = (id: number, option: any) => {
    let subQuesObj = {...subQuesHours};
    if (typeof option?.hours === 'object') {
      subQuesObj[id] = option?.hours[appType];
    }else {
      subQuesObj[id] = option?.hours;
    }
    setSubQuesHours(subQuesObj);

    // Set form data
    setFormData({...formData, which_cms:option.value});
  }

  const handleTextarea = (event: any) => {
    let websiteGoal = event.target.value;
    setFormData({...formData, main_goal_of_the_website:websiteGoal});
  }

  return (
    <QuestionWrapper>
      <QuestionText>{data?.question}</QuestionText>
      { data?.type === 'Radio' && 
        <Radio.Group>
          <Space direction="vertical">
              { data?.options.map((option: any) => 
                <RadioField key={option.id} value={option.id} onClick={() => handleRadioClick(option, data.id)}>
                  {option.value}
                </RadioField>
              )}
          </Space>
        </Radio.Group>
      }
      { data?.type === 'Checkbox' &&
        <Checkbox.Group style={{width: '100%', display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'space-between'}}>
          { data?.options.map((option: any) =>
            <CheckboxField key={option.id} value={option.id} onChange={(e) => handleCheckboxClick(e, option)}>
              {option.value}
            </CheckboxField>
          )}
        </Checkbox.Group>
      }
      { data?.type === 'Conditional' &&
        <>
          <Radio.Group>
            <Space direction="vertical">
              { data?.options.map((option: any) => 
                <RadioField key={option.id} value={option.id} onClick={() => handleConditionalClick(option)}>
                  {option.value}
                </RadioField>
              )}
            </Space>
          </Radio.Group>

          { showSubQues && data?.subQues?.map((ques: any) => 
            <SubQuestionWrapper key={ques.id}>
              <SubQuestionText>{ques?.question}</SubQuestionText>
              <Radio.Group>
                <Space direction="vertical">
                  { ques?.options.map((option: any) => 
                    <RadioField key={option.id} value={option.id} onClick={() => handleSubQuesClick(ques.id, option)}>
                      {option.value}
                    </RadioField>
                  )}
                </Space>
              </Radio.Group>
            </SubQuestionWrapper>
          )}
        </>
      }

      { showTextarea && <TextArea style={{marginTop: '35px', width: '70%'}} rows={3} maxLength={30} onChange={handleTextarea} />}
      <ButtonContainer>
        <PrevButton disabled={isFirst} onClick={handlePrev}><ArrowLeftOutlined /> Previous</PrevButton>
        <NextButton onClick={handleNext}>{btnText} <ArrowRightOutlined /></NextButton>
      </ButtonContainer>
    </QuestionWrapper>
  )
}

export default Question;